<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <ContentSelect
        :cardContent="dataContent"
        :commitPayloadData="commitPayloadData"
        :funcUpdateProgress="updateProgress"
      />
    </template>
  </div>
</template>

<script>
import ContentSelect from './components/ContentSelect.vue';
import {mapGetters} from 'vuex';

import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {ContentSelect},
  name: 'HP03',
  data() {
    return {
      dataContent: {},
      CheckWidth: window.innerWidth.toString(),
      startTime: '',
      v3Data: {},
      nextPath: null,
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.dataContent = val.templates[0];

      if (!this.dataContent.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'HP03 Watcher Call');
      if (this.nextPath) {
        this.loading = true;
        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        // //to LTK 01
        this.$router.push(onNext);
      }
    },
  },
  mounted() {
    this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);
    this.onLoad();
  },
  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();
      this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;

      //getdata
      const contentId = `HP03-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    updateProgress() {},
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          console.log('current Code = lastCode save content and clear stack');
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
};
</script>

<style>
.displayNone {
  display: None;
}
.displayBlock {
  display: block;
}
</style>
